import React from "react";
import { HowSlideBase } from 'src/pages/how/how-slide-base/HowSlideBase';
import leftBodyAnchors from './anchor-data/left-body';
import leftHeadAnchors from './anchor-data/left-head';
import rightBodyAnchors from './anchor-data/right-body';
import rightHeadAnchors from './anchor-data/right-head';
import speechAnchors from './anchor-data/speech';
import "./HowSlide1.scss";


export class HowSlide1 extends HowSlideBase {
  componentDidMount() {
    this.setupViewOnScroll({ id: 1 });
  }

  render() {
    return this.createSlide({
      step: 1,
      title: 'Empathise',
      content: <>
        <p>Design Thinking is <b>people-centred</b></p>

        <p>Understand what customers want, and where and when they want it.</p>
        <p>Working directly with the people you’re designing for keeps your solutions truly on track.</p>
        <p>Understand human needs and goals that go beyond organisational silos and technical systems.</p>
      </>,
      image: './assets/how/image-step-1.svg',
      fills: [
        { anchors: leftBodyAnchors },
        { anchors: leftHeadAnchors },
        { anchors: rightBodyAnchors },
        { anchors: rightHeadAnchors },
        { anchors: speechAnchors },
      ],
      fillDimensions: {
        x: 70,
        y: 32,
        width: 300,
        height: 300,
      }
    });
  }
}
